import { gql } from '@zenbusiness/application-commons-graphql';

export const REPORT_STOLEN_CARD_MUTATION = gql`
  mutation reportStolenCard($input: CardIdentifierInput!) {
    reportStolenCard(input: $input) {
      id
    }
  }
`;

export const REPORT_LOST_CARD_MUTATION = gql`
  mutation reportLostCard($input: CardIdentifierInput!) {
    reportLostCard(input: $input) {
      id
    }
  }
`;

export const REPLACE_CARD_MUTATION = gql`
  mutation replacePhysicalCard($input: ReplaceCardInput!) {
    replacePhysicalCard(input: $input) {
      id
    }
  }
`;

export const CREATE_CARD_MUTATION = gql`
  mutation createCard($input: CreateCardInput!) {
    createCard(input: $input) {
      id
    }
  }
`;

export const FREEZE_CARD_MUTATION = gql`
  mutation freezeCard($input: CardIdentifierInput!) {
    freezeCard(input: $input) {
      id
      type
      last4Digits
      expirationDate
      status
      createdAt
    }
  }
`;

export const UNFREEZE_CARD_MUTATION = gql`
  mutation unfreezeCard($input: CardIdentifierInput!) {
    unfreezeCard(input: $input) {
      id
      type
      last4Digits
      expirationDate
      status
      createdAt
    }
  }
`;

export const TRACK_FAILED_ACTIVATION_MUTATION = gql`
  mutation trackFailedActivation($input: CardIdentifierInput!) {
    trackFailedActivation(input: $input) {
      failureActivationCount
    }
  }
`;

export const LOG_PIN_ACTIVITY_MUTATION = gql`
  mutation logPinActivity($input: LogPinActivityInput!) {
    logPinActivity(input: $input) {
      unitCardId
      createdDatetime
    }
  }
`;
